<script setup lang="ts">
import Modal from "@/components/Modals/Modal.vue";
import { ActiviteitItem, ActiviteitLesWithTrainers } from "@/repositories/activiteit.repository";
import BestelLessenList from "./BestelLessenList.vue";
import { computed } from "vue";
import { isStartedSeriesBookable as getIsStartedSeriesBookable } from "@/helpers/activity.helper";

const props = defineProps<{
    show: boolean;
    lessen: ActiviteitLesWithTrainers[] | null;
    activiteit: ActiviteitItem | null;
}>();

const emit = defineEmits<{
    (e: "close"): void;
}>();

const close = () => {
    emit("close");
};

const isStartedSeriesBookable = computed(() => {
    return getIsStartedSeriesBookable(
        props.activiteit?.InschrijvenBegonnenReeksMogelijk,
        props.lessen,
    );
});
</script>

<template>
    <Modal :show="props.show" @close="close">
        <div class="sport-in-modal">
            <div class="sport-in-modal-header">
                <div>
                    <h2 class="sport-in-modal-heading h4">
                        Lesoverzicht
                    </h2>
                </div>
                <button @click="close" class="sport-in-close-modal-btn" aria-label="Sluit les overzicht modal">
                    <span class="icon-close" aria-hidden="true"></span>
                </button>
            </div>
            <div class="sport-in-modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <div v-if="isStartedSeriesBookable" class="alert alert-warning py-2 px-3" role="status">
                            Deze lesreeks is al begonnen. Je kunt je nog steeds inschrijven.
                        </div>
                        <BestelLessenList class="mb-0" :lessen="props.lessen" />
                    </div>
                </div>
            </div>
            <div class="sport-in-modal-footer">
                <button @click="close" class="btn btn-sm btn-sport-in-light">Sluiten</button>
            </div>
        </div>
    </Modal>
</template>
